/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Job_LabelInputs */



/**
* | output |
* | --- |
* | "Describe the job in your own words" |
*
* @param {Agent_Wizard_Job_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_job_label = /** @type {((inputs?: Agent_Wizard_Job_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Job_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreiben Sie die Aufgabe in Ihren eigenen Worten")
	return /** @type {LocalizedString} */ ("Describe the job in your own words")
});